import React, { useState } from 'react';
import axios from 'axios';
import { APP_API_URL } from '../../utils';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import DuoModal from '../../components/ui/duo-modal';

export default function Add({ open, onClose, refreshData }) {
  const user = useSelector((state) => state.auth.user);
  const [formData, setFormData] = useState({
    name: '',
    location: '',
    manager: '',
    capacity: null,
    description: '',
    is_active: true,
    user_id: user?.id,
    code: '',
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const resetForm = () => {
    setFormData({
      name: '',
      location: '',
      manager: '',
      capacity: null,
      description: '',
      is_active: true,
      user_id: user?.id,
      code: '',
    });
    setErrors({});
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${APP_API_URL}/warehouses`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await Swal.fire({
        icon: 'success',
        title: 'Succès',
        text: response.data.message || "Le magasin a été ajouté avec succès.",
        timer: 2000,
        showConfirmButton: false,
      });

      resetForm();
      onClose();
      refreshData();
    } catch (error) {
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors);
        Swal.fire({
          icon: 'error',
          title: 'Erreur de validation',
          text: 'Veuillez vérifier les champs du formulaire.',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: "Une erreur est survenue lors de l'ajout du magasin.",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <DuoModal
      title="Ajouter un magasin"
      size="lg"
      onClose={handleClose}
      footer={
        <>
          <button type="button" className="duo-btn duo-btn--ghost" onClick={handleClose} disabled={isLoading}>
            Annuler
          </button>
          <button type="submit" form="add-warehouse-form" className="duo-btn duo-btn--primary" disabled={isLoading}>
            {isLoading ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </>
      }
    >
      <form id="add-warehouse-form" onSubmit={handleSubmit}>
        <div className="duo-form-group">
          <label htmlFor="add-warehouse-name" className="duo-form-label">
            Nom du magasin *
          </label>
          <input
            type="text"
            className="duo-input"
            id="add-warehouse-name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
          {errors.name && <p className="text-danger small mt-1 mb-0">{errors.name[0]}</p>}
        </div>
        <div className="row g-2">
          <div className="col-md-6">
            <div className="duo-form-group">
              <label htmlFor="add-warehouse-location" className="duo-form-label">
                Emplacement
              </label>
              <input
                type="text"
                className="duo-input"
                id="add-warehouse-location"
                name="location"
                value={formData.location}
                onChange={handleChange}
              />
              {errors.location && <p className="text-danger small mt-1 mb-0">{errors.location[0]}</p>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="duo-form-group">
              <label htmlFor="add-warehouse-manager" className="duo-form-label">
                Responsable
              </label>
              <input
                type="text"
                className="duo-input"
                id="add-warehouse-manager"
                name="manager"
                value={formData.manager}
                onChange={handleChange}
              />
              {errors.manager && <p className="text-danger small mt-1 mb-0">{errors.manager[0]}</p>}
            </div>
          </div>
        </div>
        <div className="row g-2">
          <div className="col-md-6">
            <div className="duo-form-group">
              <label htmlFor="add-warehouse-capacity" className="duo-form-label">
                Capacité
              </label>
              <input
                type="number"
                className="duo-input"
                id="add-warehouse-capacity"
                name="capacity"
                value={formData.capacity ?? ''}
                onChange={handleChange}
              />
              {errors.capacity && <p className="text-danger small mt-1 mb-0">{errors.capacity[0]}</p>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="duo-form-group">
              <label htmlFor="add-warehouse-code" className="duo-form-label">
                Code
              </label>
              <input
                type="text"
                className="duo-input"
                id="add-warehouse-code"
                name="code"
                value={formData.code}
                onChange={handleChange}
              />
              {errors.code && <p className="text-danger small mt-1 mb-0">{errors.code[0]}</p>}
            </div>
          </div>
        </div>
        <div className="duo-form-group">
          <label htmlFor="add-warehouse-description" className="duo-form-label">
            Description
          </label>
          <textarea
            className="duo-input"
            id="add-warehouse-description"
            name="description"
            rows={3}
            value={formData.description}
            onChange={handleChange}
          />
          {errors.description && <p className="text-danger small mt-1 mb-0">{errors.description[0]}</p>}
        </div>
        <div className="duo-form-group mb-0">
          <label className="duo-form-label d-flex align-items-start gap-2">
            <input
              type="checkbox"
              className="form-check-input mt-1"
              name="is_active"
              checked={formData.is_active}
              onChange={handleChange}
            />
            <span>
              Magasin actif
              <span className="d-block fw-normal" style={{ fontSize: '0.78rem', color: '#777' }}>
                Décochez pour rendre le magasin inactif.
              </span>
            </span>
          </label>
        </div>
      </form>
    </DuoModal>
  );
}
